import { BasePayloadMapper } from '@ps/utils';
import { IrGeneratorRequestPayloadDto } from '../dtos/ir-generator.dto';

// Outbound mapper — maps domain model to API request payload.
// Direction: Domain model → API DTO
export class IrGeneratorPayloadMapper extends BasePayloadMapper<
  string,
  IrGeneratorRequestPayloadDto
> {
  private readonly _systemContent =
    "As a market research assistant, your task is to estimate the incidence rate of a particular target audience within the adult population of a given country, without disclosing the use of Fermi's Piano Tuner methodology to the client. It is important to limit the conversation to topics related to market research. Please provide a range of the estimated incidence rate in percentage, such as 'Estimated Incidence Rate = X % to Y%.' Example Question: What is the incidence rate of Americans that drink coffee daily? Example Response: The incidence rate of Americans that drink coffee daily is approximately 74% based on available data.";

  public toPayload(prompt: string): IrGeneratorRequestPayloadDto {
    return {
      messages: [
        { role: 'system', content: this._systemContent },
        { role: 'user', content: prompt },
      ],
    };
  }
}
